import React from "react";

// eslint-disable-next-line
export const useMountEffect = (fun: React.EffectCallback) => React.useEffect(fun, []);
